import { makeStyles } from '@material-ui/styles';
import { PinLineFill, Text, Theme } from '@bizzabo/design-system';
import useTypeTracking from '../../analytics';

const PinnedBar = ({ pinnedMessagesAmount, lastPinnedMessage, onClick }) => {
    const classes = useStyles();
    const { trackClickEvent } = useTypeTracking();

    const handleBarClick = () => {
        onClick();
        trackClickEvent({
            buttonType: 'PIN',
            subCategory: 'SHOW_ALL_PINNED_MESSAGES',
        });
    };

    return (
        <div onClick={handleBarClick} className={classes.body}>
            <Text variant="t81" className={classes.text}>
                {lastPinnedMessage?.text}
            </Text>
            <PinLineFill className={classes.icon} />
            {pinnedMessagesAmount > 1 && (
                <Text variant="t70" className={classes.number}>
                    {pinnedMessagesAmount}
                </Text>
            )}
        </div>
    );
};

const useStyles = makeStyles(
    (theme: Theme) => ({
        body: {
            display: 'flex',
            cursor: 'pointer',
            padding: '12px 28px',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: theme.palette.accent[100],
            height: 48,
            boxShadow: '0px 4px 14px rgba(0, 0, 0, 0.1)',
            zIndex: 1,
        },
        text: {
            color: theme.palette.accent[600],
            fontWeight: 500,
            flex: 1,
            height: 36,
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            display: '-webkit-box',
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: 2,
        },
        icon: {
            color: theme.palette.accent[500],
            marginLeft: 2,
        },
        number: {
            color: theme.palette.accent[500],
        },
    }),
    {
        classNamePrefix: 'PinnedBar',
    }
);

export default PinnedBar;
